import React from 'react';
import { Route, Switch } from 'react-router';
import { Redirect } from 'react-router-dom';
import ConnectedQuotesTabs from './QuotesTabs';
import QuoteQuestion from './QuoteQuestion';
import QuoteQuestionInbox from './QuoteQuestionInbox';
import routes from '../common/routes';

export const Quotes = () => {
  return (
    <Switch>
      <Route exact path={routes.quotes.questions} component={QuoteQuestionInbox} />
      <Route
        exact
        path={`${routes.quotes.index}/questions/:folderId/:questionId`}
        component={QuoteQuestion}
      />
      <Route
        exact
        path={routes.quotes.index}
        render={() => <Redirect to={`${routes.quotes.index}${routes.quotes.types[0]}`} />}
      />
      <Route path={`${routes.quotes.index}/:quotesType`} component={ConnectedQuotesTabs} />
    </Switch>
  );
};
